import { ItemList } from 'v2/models';

export type TFilterFieldTypes = 'string' | 'number' | 'date' | 'owner';

export enum EFilterFieldTypes {
  string = 'string',
  number = 'number',
  date = 'date',
  owner = 'owner',
}

export interface IFilterableField {
  displayName: string;
  name: string;
  type: EFilterFieldTypes;
}

export enum EFilterOperations {
  equals = 'equals',
  notEquals = 'notEquals',
  known = 'known',
  unknown = 'unknown',
  gte = 'gte',
  lte = 'lte',
  between = 'between',
  containsAny = 'containsAny',
  notContainsAny = 'notContainsAny',
  empty = 'empty',
}

export interface IAppliedFilter {
  field: IFilterableField;
  operation: EFilterOperations;
  value:
    | string
    | string[]
    | number
    | number[]
    | Date
    | Date[]
    | boolean
    | ItemList;
}

export interface TParamInfo {
  baseField: string;
  operation: string;
  value: string;
}
